import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, {FormBody, FormActions, DateInput, SelectInput, TextInput} from '../../../Form';

@inject('hydrologyStore')
@observer
class TableAdd extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    hydrologyStore: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.shape().isRequired,
  }

  @observable item = {
    start_date: new Date(),
    end_date: new Date(),
    table_no: '',
  };

  slug = 'hydrology/rt_method/table_list';
  title = 'Add Listing';

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    if(this.props.hydrologyStore.selectedStation === '')
      this.context.router.push(this.slug);

    this.props.hydrologyStore.fetchUniqueTypeNumbersByStationIndex();
  }

  @action onTypeNoChange = (e) => { this.item.table_no = e.target.value; }

  @action onStartDateChange = (e) => {
    this.item.start_date =  e.target.value;
  };

  @action onEndDateChange = (e) => {
    this.item.end_date =  e.target.value;
  };

  handleSave(e) {
    e.preventDefault();
    const {table_no, start_date, end_date} = this.item;

    if(table_no !== '') {
      const {hydrologyStore} = this.props;

      const payload = {
        start_date: new Date(start_date).toISOString(),
        end_date: new Date(end_date).toISOString(),
        station_index: hydrologyStore.selectedStation
      };

      if (table_no !== "New" && table_no !== "new" && table_no !== "") {
        payload.table_no = table_no;
      }

      hydrologyStore.insertRatingTable(payload).then((res) => {
        if(!res.error)
          this.context.router.push(this.slug);
      });
    }
  }

  render() {
    const { hydrologyStore } = this.props;
    const { selectedStation, associatedTSSStation, typeNumbers } = hydrologyStore;

    if (hydrologyStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={hydrologyStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput readOnly={true} label={"Station Index"} value={selectedStation}/>
            {associatedTSSStation && <TextInput readOnly={true} label={"Station Name"} value={associatedTSSStation.name}/>}
            <SelectInput options={[{rating_type_no: 'New'}, ...typeNumbers.map(item => ({rating_type_no: `${item.rating_type_no}`}))]}
                         label={"Table No"}
                         fields={{label: 'rating_type_no', value: 'rating_type_no'}}
                         onChange={this.onTypeNoChange}
                         value={this.item.table_no}/>
            <DateInput value={this.item.start_date}
                       onChange={this.onStartDateChange}
                       label={'Start Date'}/>
            <DateInput value={this.item.end_date}
                       onChange={this.onEndDateChange}
                       label={'End Date'}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default TableAdd;



// WEBPACK FOOTER //
// ./src/components/Hydrology/RT Method/Table/TableAdd.js